module.exports = __webpack_public_path__ + "static/img/11.49f1c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/11.png
// module id = e9gy
// module chunks = 1